import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import load from '@/components/loads/load'
import indexOne from '@/components/pages/indexOne'
import details from '@/components/details/details'
import allBusinesses from '@/components/allBusinesses/allBusinesses'
// import ceshi from '@/components/allBusinesses/ceshi'
// import kongbai from '@/components/allBusinesses/kongbai'
import bottom from '@/components/footerTo/bottom'
import scan from '@/components/scan/scan'
import card from '@/components/card/card'
import infor from '@/components/infor/infor'
import deal from '@/components/deal/deal'
import invite from '@/components/invite/invite'
import sureInvite from '@/components/sureInvite/sureInvite'
import setting from '@/components/setting/setting'
import personage from '@/components/personage/personage'
// import consumption from '@/components/consumption/consumption'
import conuccess from '@/components/conuccess/conuccess'
// import identity from '@/components/change/identity'
import safety from '@/components/change/safety'
import numberChange from '@/components/change/numberChange'
import pay from '@/components/change/pay'
import birthday from '@/components/change/birthday'
import signature from '@/components/change/signature'
// import activity from '@/components/change/activity'
import photo from '@/components/change/photo'
import aboutMy from '@/components/change/aboutMy'
import relation from '@/components/change/relation'
import user from '@/components/change/user'
import alldeil from '@/components/change/alldeil'
import informationOne from '@/components/change/informationOne'
import detailOne from '@/components/change/detailOne'
import gender from '@/components/change/gender'
import login from '@/components/login/login'
import forget from '@/components/login/forget'
import changePassword from '@/components/login/changePassword'

import cardBag from '@/components/homepage/cardBag'
import find from '@/components/homepage/find'
import mine from '@/components/homepage/mine'

import cardDetail from '@/components/card/cardDetail'
import shareFriends from '@/components/card/shareFriends'
import more from '@/components/card/more'

import searchCard from '@/components/cardBag/searchCard'
import message from '@/components/cardBag/message'
import activityDetail from '@/components/cardBag/activityDetail'
import consumptionHistory from '@/components/consumption/consumptionHistory'

import chargeDetail from '@/components/orderDetails/chargeDetail'
import consumeDetail from '@/components/orderDetails/consumeDetail'
import payDetail from '@/components/orderDetails/payDetail'
import refundDetail from '@/components/orderDetails/refundDetail'
import unpaidDetail from '@/components/orderDetails/unpaidDetail'

import chargeSuccessDetail from '@/components/messageDetails/chargeSuccessDetail'
import consumeSuccessDetail from '@/components/messageDetails/consumeSuccessDetail'
import inviteVip from '@/components/messageDetails/inviteVip'
import paySuccessDetail from '@/components/messageDetails/paySuccessDetail'
import refundSuccessDetail from '@/components/messageDetails/refundSuccessDetail'
import systemMessage from '@/components/messageDetails/systemMessage'

import personalInformation from '@/components/mine/personalInformation'
import zhanghuSafety from '@/components/mine/zhanghuSafety'
import msg from '@/components/mine/msg'
import xiaofeiList from '@/components/mine/xiaofeiList'
import about from '@/components/mine/about'
import feedback from '@/components/mine/feedback'
import touxiang from '@/components/mine/touxiang'
import changePhone from '@/components/mine/changePhone'
import setPassword from '@/components/mine/setPassword'
import modifyPassword from '@/components/mine/modifyPassword'
import sign from '@/components/mine/sign'
import identity from '@/components/mine/identity'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/load',
      name: 'load',
      component: load
    },
    {
      path: '/gender',
      name: 'gender',
      component: gender
    },
    {
      path: '/HelloWorld',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/indexOne',
      name: 'indexOne',
      component: indexOne
    },
    {
      path: '/details',
      name: 'details',
      component: details
    },
    {
      path: '/bottom',
      name: 'bottom',
      component: bottom
    },
    {
      path: '/scan',
      name: 'scan',
      component: scan
    },
    {
      path: '/card',
      name: 'card',
      component: card
    },
    {
      path: '/infor',
      name: 'infor',
      component: infor
    },
    {
      path: '/deal',
      name: 'deal',
      component: deal
    },
    {
      path: '/invite',
      name: 'invite',
      component: invite
    },
    {
      path: '/sureInvite',
      name: 'sureInvite',
      component: sureInvite
    },
    {
      path: '/setting',
      name: 'setting',
      component: setting
    },
    {
      path: '/personage',
      name: 'personage',
      component: personage
    },
    {
      path: '/identity',
      name: 'identity',
      component: identity
    },
    {
      path: '/safety',
      name: 'safety',
      component: safety
    },
    {
      path: '/numberChange',
      name: 'numberChange',
      component: numberChange
    },
    {
      path: '/pay',
      name: 'pay',
      component: pay
    },
    {
      path: '/birthday',
      name: 'birthday',
      component: birthday
    },
    {
      path: '/signature',
      name: 'signature',
      component: signature
    },
    {
      path: '/photo',
      name: 'photo',
      component: photo
    },
    {
      path: '/aboutMy',
      name: 'aboutMy',
      component: aboutMy
    
    },
    {
      path: '/relation',
      name: 'relation',
      component: relation
    },
    {
      path: '/conuccess',
      name: 'conuccess',
      component: conuccess
    },
    {
      path: '/user',
      name: 'user',
      component: user
    },
    {
      path: '/alldeil',
      name: 'alldeil',
      component: alldeil
    },
    {
      path: '/informationOne',
      name: 'informationOne',
      component: informationOne
    },
    {
      path: '/detailOne',
      name: 'detailOne',
      component: detailOne
    },
    {
      path: '/allBusinesses',
      name: 'allBusinesses',
      component: allBusinesses
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/forget',
      name: 'forget',
      component: forget
    },
    {
      path: '/changePassword',
      name: 'changePassword',
      component: changePassword
    },
    {
      path: '/cardBag',
      name: 'cardBag',
      component: cardBag
    },
    {
      path: '/find',
      name: 'find',
      component: find
    },
    {
      path: '/mine',
      name: 'mine',
      component: mine
    },
    {
      path: '/cardDetail',
      name: 'cardDetail',
      component: cardDetail
    },
    {
      path: '/searchCard',
      name: 'searchCard',
      component: searchCard
    },
    {
      path: '/message',
      name: 'message',
      component: message
    },
    {
      path: '/consumptionHistory',
      name: 'consumptionHistory',
      component: consumptionHistory
    },
    {
      path: '/chargeDetail',
      name: 'chargeDetail',
      component: chargeDetail
    },
    {
      path: '/consumeDetail',
      name: 'consumeDetail',
      component: consumeDetail
    },
    {
      path: '/payDetail',
      name: 'payDetail',
      component: payDetail
    },
    {
      path: '/refundDetail',
      name: 'refundDetail',
      component: refundDetail
    },
    {
      path: '/unpaidDetail',
      name: 'unpaidDetail',
      component: unpaidDetail
    },
    {
      path: '/chargeSuccessDetail',
      name: 'chargeSuccessDetail',
      component: chargeSuccessDetail
    },
    {
      path: '/consumeSuccessDetail',
      name: 'consumeSuccessDetail',
      component: consumeSuccessDetail
    },
    {
      path: '/inviteVip',
      name: 'inviteVip',
      component: inviteVip
    },
    {
      path: '/paySuccessDetail',
      name: 'paySuccessDetail',
      component: paySuccessDetail
    },
    {
      path: '/refundSuccessDetail',
      name: 'refundSuccessDetail',
      component: refundSuccessDetail
    },
    {
      path: '/systemMessage',
      name: 'systemMessage',
      component: systemMessage
    },
    {
      path: '/personalInformation',
      name: 'personalInformation',
      component: personalInformation
    },
    {
      path: '/zhanghuSafety',
      name: 'zhanghuSafety',
      component: zhanghuSafety
    },
    {
      path: '/msg',
      name: 'msg',
      component: msg
    },
    {
      path: '/xiaofeiList',
      name: 'xiaofeiList',
      component: xiaofeiList
    },
    {
      path: '/about',
      name: 'about',
      component: about
    },
    {
      path: '/feedback',
      name: 'feedback',
      component: feedback
    },
    {
      path: '/touxiang',
      name: 'touxiang',
      component: touxiang
    },
    {
      path: '/shareFriends',
      name: 'shareFriends',
      component: shareFriends
    },
    {
      path: '/changePhone',
      name: 'changePhone',
      component: changePhone
    },
    {
      path: '/activityDetail',
      name: 'activityDetail',
      component: activityDetail
    },
    {
      path: '/setPassword',
      name: 'setPassword',
      component: setPassword
    },
    {
      path: '/modifyPassword',
      name: 'modifyPassword',
      component: modifyPassword
    },
    {
      path: '/sign',
      name: 'sign',
      component: sign
    },
    {
      path: '/more',
      name: 'more',
      component: more
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js